import { SET_MIAW_CHAT_INFO_PRESENT } from "constants-lib/actionTypes"

export const setMiawChatInfoPresent = (payload) => ({
  type: SET_MIAW_CHAT_INFO_PRESENT,
  payload,
})
